module.exports = "<section class=\"addCard\" id=\"addCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n\n        <div class=\"span10\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/noop-loader!./pages/xo-add-card/template.html
// module id = ../node_modules/noop-loader/index.js!./pages/xo-add-card/template.html
// module chunks = 0